import React from 'react';
import { Link } from 'react-router-dom';
import PageMeta from '../SEO/PageMeta';
import logoImg from '../../assets/logo.png';
import founder1 from '../../assets/founder-1.png';
import founder2 from '../../assets/founder-2.png';
import founder3 from '../../assets/founder-3.png';
import './Pages.css';

const founders = [
  { name: 'Om Ujjwal Singh', role: 'Co-founder', photo: founder1, tone: 'rust' },
  { name: 'Akshay J Vainsh', role: 'Co-founder', photo: founder3, tone: 'teal' },
  { name: 'Alok Silswal',    role: 'Co-founder', photo: founder2, tone: 'gold' },
];

export default function AboutPage() {
  return (
    <div className="pg">
      <PageMeta
        title="About CivilFox | UPSC Preparation Tools"
        description="Meet the CivilFox founders and learn about the study tools we are building for UPSC Civil Services preparation."
        path="/about"
      />
      <header className="pg-top">
        <Link to="/" aria-label="CivilFox home"><img src={logoImg} alt="CivilFox" /></Link>
      </header>
      <main className="pg-main">
        <h1>About CivilFox</h1>
        <p>CivilFox brings together exam-focused current affairs, previous-year question practice, mock tests, flashcards, and revision tools for Civil Services aspirants.</p>
        <div className="pg-founders">
          {founders.map(f => (
            <article key={f.name} className={`pg-founder ${f.tone}`}>
              <img src={f.photo} alt={f.name} />
              <h2>{f.name}</h2>
              <p>{f.role}</p>
            </article>
          ))}
        </div>
      </main>
    </div>
  );
}